module.exports = __webpack_public_path__ + "resources/img/img_docuone2_m.e32b964c123eac9530674fcfe4dd6bc1.png";